import moment from "moment-timezone";
import React from "react";
import { CITIES, getLogo, STADIUMS } from "../../util";
import "./TodayPredictionCard.css";

const LOGO_SIZE = 128;

const Card = ({
  home,
  away,
  startTime,
  predictedMargin,
  predictedWinner,
}: {
  home: string;
  away: string;
  startTime: string;
  predictedMargin: number;
  predictedWinner: string;
}) => {
  return (
    <>
      <div className="NextGameCard-container1">
        <div className="NextGameCard-matchup">
          <div className="NextGameCard-teamContainerTop">
            <img className="NextGameGard-logo" src={getLogo(away, LOGO_SIZE)} />
            <h1 className="NextGameCard-abbrev">{away}</h1>
          </div>
          <hr style={{ width: "95%" }} className="NextGameCard-line"></hr>
          <div className="NextGameCard-teamContainerBottom">
            <img className="NextGameGard-logo" src={getLogo(home, LOGO_SIZE)} />
            <h1 className="NextGameCard-abbrev">{home}</h1>
          </div>
        </div>
        <div className="NextGameCard-setting">
          <div className="NextGameCard-time">
            {moment(startTime, "HH:mm").format("hh:mm A")} ET
          </div>
          <div className="NextGameCard-time"> {STADIUMS[home]}</div>
          <div className="NextGameCard-time"> {CITIES[home]}</div>

          <h2>Your Prediction:</h2>
          <div className="TodayPredictionCard-predictionText">
            {predictedWinner} wins by {predictedMargin}
          </div>
        </div>
      </div>
    </>
  );
};

export default Card;
